import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"
import Switch from "react-switch"
import { URL_PATHS } from "constants/index"
import { generatePath, Link } from "react-router-dom"

const documentListColumn = statusChangeHandler => {
  return [
    {
      text: "Order",
      dataField: "order",
      formatter: (cellContent, row) => {
        return <i className="bx bx-sm bx-menu"></i>
      },
    },
    {
      text: "Document Name",
      dataField: "name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, document) => <>{document.name}</>,
    },
    {
      text: "Status",
      dataField: "status",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, document) => (
        <Switch
          checked={document.status === 1}
          onChange={() => {
            statusChangeHandler(document, document.status === 1 ? 0 : 1)
          }}
          onColor="#2ECC71"
          offColor="#E74C3C"
          uncheckedIcon={false}
          checkedIcon={false}
          height={20}
          width={35}
        />
      ),
    },
    {
      text: "Results",
      dataField: "results",
      formatter: (cellContent, document) =>
        document?.event_id ? (
          <Link
            to={generatePath(URL_PATHS.DOCUMENT_REPORTS, {
              event_id: document?.event_id,
              feature_id: document?.id,
            })}
          >
            Open
          </Link>
        ) : (
          "Open"
        ),
    },
  ]
}

export default documentListColumn
